import { render, staticRenderFns } from "./Crypto.vue?vue&type=template&id=4625cfd5&scoped=true"
import script from "./Crypto.vue?vue&type=script&lang=js"
export * from "./Crypto.vue?vue&type=script&lang=js"
import style0 from "./Crypto.vue?vue&type=style&index=0&id=4625cfd5&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4625cfd5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4625cfd5')) {
      api.createRecord('4625cfd5', component.options)
    } else {
      api.reload('4625cfd5', component.options)
    }
    module.hot.accept("./Crypto.vue?vue&type=template&id=4625cfd5&scoped=true", function () {
      api.rerender('4625cfd5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/dashboard/footer-pages/crypto/Crypto.vue"
export default component.exports